import { SUCCESS_TOAST, ERROR_TOAST } from "../../constants/toast.constants";
import {
  authConstants,
  globalConstants,
  homeConstants,
  AGENT_REGISTRATION_MESSAGE,
} from "../../constants";
import { customToast } from "../../shared/utility";
import { custom, success, failure } from "./utilities";
import { authService } from "../../services/auth.service";
import { subscriptionActions } from "../../redux/actions/subscription.actions";

const {
  LOGIN,
  RESET,
  FORGOT,
  REGISTER,
  VERIFY_EMAIL,
  UPDATE_USER_ROLE,
  AGENT_REGISTRATION,
  UPDATE_CURRENT_USER,
  IS_NAVIGATE_TO_DEFAULT,
} = authConstants;
const { DEFAULT_CURRENCY } = homeConstants;
const { SPINNER_DIACTIVATE, SPINNER_ACTIVATE } = globalConstants;

const login = (data, successFunction) => {
  return (dispatch) => {
    dispatch(custom(LOGIN, SPINNER_ACTIVATE));
    authService
      .login(data)
      .then(
        (response) => {
          const userRole = response.user.roleIds[0];
          dispatch(
            subscriptionActions.getUserSubscriptionStatus(userRole, true)
          );
          dispatch(custom(response.user.defaultCurrency, DEFAULT_CURRENCY));
          dispatch(success(response, LOGIN));
          successFunction();
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        dispatch(custom(LOGIN, SPINNER_DIACTIVATE));
      });
  };
};

const register = (data, successFunction, isRequiredReLogin) => {
  return (dispatch) => {
    dispatch(custom(REGISTER, SPINNER_ACTIVATE));
    authService
      .register(data)
      .then(
        (response) => {
          successFunction(response.data);
          if (!response.data?.needsConfirmation) {
            dispatch(success({}, REGISTER));
            if (isRequiredReLogin) {
              // Add a 1 second delay before logging out
              setTimeout(() => logout(), 1000);
            }
          }
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        dispatch(custom(REGISTER, SPINNER_DIACTIVATE));
      });
  };
};

const forgotPasswordSendEmail = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(FORGOT, SPINNER_ACTIVATE));
    authService
      .forgotPasswordSendEmail(data)
      .then(
        (response) => {
          onSuccess();
          dispatch(success({}, FORGOT));
          customToast(response.msg, SUCCESS_TOAST);
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        dispatch(custom(FORGOT, SPINNER_DIACTIVATE));
      });
  };
};

const resetPassword = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(RESET, SPINNER_ACTIVATE));
    authService
      .resetPassword(data)
      .then(
        (response) => {
          onSuccess();
          dispatch(success(response.data, RESET));
          customToast(response.msg, SUCCESS_TOAST);
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        dispatch(custom(RESET, SPINNER_DIACTIVATE));
      });
  };
};

const logout = () => {
  authService.logout();
};

const agentRegisteration = (data, successFunction, isRequiredReLogin) => {
  return (dispatch) => {
    dispatch(custom(AGENT_REGISTRATION, SPINNER_ACTIVATE));
    authService
      .agentRegisteration(data)
      .then(
        (response) => {
          successFunction();
          dispatch(success(response?.data, AGENT_REGISTRATION));
          const message = isRequiredReLogin
            ? AGENT_REGISTRATION_MESSAGE
            : response.msg;
          customToast(message, SUCCESS_TOAST);
          if (isRequiredReLogin) {
            // Add a 1 second delay before logging out
            setTimeout(() => logout(), 1000);
          }
        },
        (error) => {
          customToast(error[1], ERROR_TOAST);
        }
      )
      .finally(() => {
        dispatch(custom(AGENT_REGISTRATION, SPINNER_DIACTIVATE));
      });
  };
};

// Action to verify user email
const verifyEmail = (body) => (dispatch) => {
  dispatch(custom(VERIFY_EMAIL, globalConstants.SPINNER_ACTIVATE));
  authService
    .verifyEmail(body)
    .then(
      (response) => {
        dispatch(success(response.data, VERIFY_EMAIL));
      },
      (error) => {
        dispatch(failure(null, VERIFY_EMAIL));
      }
    )
    .finally(() =>
      dispatch(custom(VERIFY_EMAIL, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateUser = (data) => (dispatch) =>
  dispatch(success(data, UPDATE_CURRENT_USER));

const updateUserRole = (roleId, navigate = true) => {
  return (dispatch) => {
    dispatch(custom(roleId, UPDATE_USER_ROLE));
    dispatch(subscriptionActions.getUserSubscriptionStatus(roleId, navigate));
  };
};

const setIsNavigateToDefault = (flag) => (dispatch) =>
  dispatch(custom(flag, IS_NAVIGATE_TO_DEFAULT));

export const authActions = {
  login,
  logout,
  register,
  updateUser,
  verifyEmail,
  resetPassword,
  updateUserRole,
  agentRegisteration,
  setIsNavigateToDefault,
  forgotPasswordSendEmail,
};
